// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Kenya from '../_raw/flag/icon_flag_kenya.png';

export default () => <img src={Kenya} alt="Kenya" />;
